(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["awk-product-upsells"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('awk-product-upsells')) {
    let cardSequence = 0;
    class AwkProductUpsells extends HTMLElement {
      connectedCallback() {
        if (this.dataset.state === 'ready' || this.observer) return;
        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.loadProducts();
        }, { rootMargin: '160px 0px' });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
        this.controller?.abort();
      }

      uniqueIds(card) {
        const suffix = '-AwkProductRecommendation-' + ++cardSequence;
        const ids = new Map();
        card.querySelectorAll('[id]').forEach((element) => {
          ids.set(element.id, element.id + suffix);
          element.id += suffix;
        });
        card.querySelectorAll('[for], [form], [aria-controls], [aria-labelledby], [aria-describedby], [href^="#"]').forEach((element) => {
          ['for', 'form', 'aria-controls', 'aria-labelledby', 'aria-describedby'].forEach((attribute) => {
            const value = element.getAttribute(attribute);
            if (value) element.setAttribute(attribute, value.split(/\s+/).map((id) => ids.get(id) || id).join(' '));
          });
          const href = element.getAttribute('href');
          if (href?.startsWith('#') && ids.has(href.slice(1))) element.setAttribute('href', '#' + ids.get(href.slice(1)));
        });
      }

      async loadProducts() {
        if (this.dataset.state === 'loading' || this.dataset.state === 'ready') return;
        this.dataset.state = 'loading';
        this.controller = new AbortController();
        const timer = setTimeout(() => this.controller.abort(), 10000);
        try {
          const type = this.dataset.productType.trim();
          const url = new URL(this.dataset.searchUrl, location.origin);
          url.searchParams.set('q', 'product_type:"' + type.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"');
          url.searchParams.set('type', 'product');
          url.searchParams.set('view', 'awk-cart-feed');
          url.searchParams.set('options[unavailable_products]', 'hide');
          const current = new URL(location.href);
          ['preview_theme_id', '_fd', 'pb'].forEach((key) => {
            if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
          });
          const response = await fetch(url, { credentials: 'same-origin', signal: this.controller.signal, headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error('Recommendation feed unavailable');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (!this.isConnected) return;
          const excluded = new Set([this.dataset.productId, ...(this.dataset.cartProductIds || '').split(',')]);
          const seen = new Set();
          const cards = [...html.querySelectorAll('[data-awk-cart-upsell-feed] .awk-cart-upsell-card[data-product-id]')].filter((card) => {
            const id = card.dataset.productId;
            if (excluded.has(id) || seen.has(id) || (card.dataset.productType || '').trim().toLocaleLowerCase('de-DE') !== type.toLocaleLowerCase('de-DE')) return false;
            seen.add(id);
            return true;
          }).slice(0, 4);
          if (!cards.length) {
            this.dataset.state = 'empty';
            this.hidden = true;
            return;
          }
          cards.forEach((card) => this.uniqueIds(card));
          this.querySelector('.awk-product-upsells__list').replaceChildren(...cards);
          this.querySelector('.awk-product-upsells__content').hidden = false;
          this.dataset.state = 'ready';
        } catch (error) {
          if (!this.isConnected) return;
          this.dataset.state = 'error';
          this.hidden = true;
        } finally {
          clearTimeout(timer);
        }
      }
    }
    customElements.define('awk-product-upsells', AwkProductUpsells);
  }
  } catch(e) { console.error(e); }
})();

})();
